import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import analytics from "../services/analytics";
import Spinner from "../components/common/Spinner";
import AuthCard from "./AuthCard";
import { colors, typography, buttons, form } from "../styles/index";

const API_BASE = process.env.REACT_APP_API_URL;

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const message = useLocation().state?.message;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a valid work email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/login`, new URLSearchParams({ username: email, password }));
      analytics.trackLogin("email");
      onLogin(res.data.token, res.data.avatar, res.data.refresh_token);
      navigate("/app");
    } catch {
      analytics.event("login_failed");
      setError("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard subtitle="Sign in to your team's studio">
      {message && <div style={{ ...typography.small, background: colors.primarySoft, padding: 12, borderRadius: 8, marginBottom: 16 }}>{message}</div>}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label style={form.label} htmlFor="email">Work email</label>
          <input id="email" type="email" autoComplete="email" style={form.input} disabled={loading} value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={form.label} htmlFor="password">Password</label>
          <input id="password" type="password" autoComplete="current-password" style={form.input} disabled={loading}
            value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          <div style={{ ...typography.small, textAlign: "right", marginTop: 6 }}>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
        </div>
        {error && <div style={{ ...form.error, marginBottom: 12 }} role="alert">{error}</div>}
        <button type="submit" disabled={loading} style={{ ...buttons.primary, width: "100%", opacity: loading ? 0.7 : 1 }}>
          {loading ? <><Spinner size={14} /> Signing in...</> : "Sign in"}
        </button>
        <p style={{ ...typography.small, marginTop: 20, textAlign: "center", color: colors.textMuted }}>
          New here? <Link to="/register">Create your team&rsquo;s account</Link> or <Link to="/try-demo">try the demo</Link>.
        </p>
        <p style={{ ...typography.small, textAlign: "center", color: colors.textMuted }}>
          By signing in, you agree to our <Link to="/terms">Terms</Link> and <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </form>
    </AuthCard>
  );
}
